import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { Store } from "@ngrx/store";
import { CORE_ROUTE, CoreState, DepositLimitConfigService, DepositLimitRequiredService } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { DepositLimitRequiredDialogService } from "./deposit-limit-required-dialog.service";

@Injectable({
	providedIn: "root",
})
export class DepositLimitRequiredDialogGuard implements CanActivate {
	constructor(
		private depositLimitRequiredService: DepositLimitRequiredService,
		private depositLimitRequiredDialogService: DepositLimitRequiredDialogService,
		private config: DepositLimitConfigService,
		private store: Store<CoreState>
	) {}

	canActivate(): Observable<boolean> {
		if (!this.config.getIsDepositLimitRequiredWithDialog()) {
			return of(true);
		}

		return this.depositLimitRequiredService.isDepositLimitsMissing$().pipe(
			map((limitsMissing) => {
				if (limitsMissing) {
					this.store.dispatch(RouteAction.navigate(CORE_ROUTE.home));
					this.depositLimitRequiredDialogService.openDialog();
					return false;
				}
				return true;
			})
		);
	}
}
